import { useState, useContext } from 'react';
import { Row } from 'react-bootstrap';
import { getPhoneNumberLength, getWindowDimension } from 'common/utils';
import { CountryContext } from 'CountryContext';
import { Lottie } from 'components/Lottie';
import { SubmittedContext } from 'SubmittedContext';
import { WishListForm } from 'components/WaitListInput/WishListForm';
import { PERSONAS } from 'common/constants';
import animationData from 'common/images/success-lottie.json';
import 'components/WaitListInput/index.scss';

export const WaitListInput = ({ type }) => {
  const { submitted } = useContext(SubmittedContext);
  const { country } = useContext(CountryContext);

  const [formVisible, setFormVisible] = useState(false);
  const [number, setNumber] = useState('');

  const onNumberChange = (event) => {
    const { value } = event.target;
    setNumber(value);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setFormVisible(true);
  };

  if (submitted && !formVisible) {
    return (
      <Row
        noGutters
        className="align-items-center justify-content-center justify-content-lg-start px-5 px-md-0"
      >
        <Lottie width={36} height={36} options={{ animationData }} />
        <p className="success-text ml-2 mt-md-0">We&apos;ve added you to the waitlist</p>
      </Row>
    );
  }

  if (getWindowDimension().width >= 768) {
    return (
      <>
        <form onSubmit={onSubmit}>
          <Row noGutters className="justify-content-center justify-content-lg-start mx-2 mx-sm-0">
            <input
              type="tel"
              required
              pattern="^[0-9]+$"
              minLength={getPhoneNumberLength(country)}
              maxLength={getPhoneNumberLength(country)}
              placeholder={`Phone Number ${type === PERSONAS.PARENT ? '(Parent)' : '(Teen)'}`}
              title="Enter a valid phone number"
              value={number}
              onChange={onNumberChange}
              className="waitlist-input__number"
            />
            <input type="submit" value={"Let's Go"} className="waitlist-input__submit" />
          </Row>
        </form>
        <WishListForm
          type={type}
          phone={number}
          visible={formVisible}
          onClose={() => setFormVisible(false)}
        />
      </>
    );
  }

  return (
    <>
      <form onSubmit={onSubmit}>
        <Row noGutters className="justify-content-center">
          <input
            type="tel"
            required
            pattern="^[0-9]+$"
            minLength={getPhoneNumberLength(country)}
            maxLength={getPhoneNumberLength(country)}
            placeholder={`Phone Number ${type === PERSONAS.PARENT ? '(Parent)' : '(Teen)'}`}
            title="Enter a valid phone number"
            value={number}
            onChange={onNumberChange}
            className="waitlist-input__number"
          />
        </Row>
        <Row noGutters className="justify-content-center">
          <input type="submit" value={"Let's Go"} className="waitlist-input__submit" />
        </Row>
      </form>
      <WishListForm
        type={type}
        phone={number}
        visible={formVisible}
        onClose={() => setFormVisible(false)}
      />
    </>
  );
};
